export default __webpack_public_path__ + "static/media/Logo 3.54f9abb6.png";